import NumberFormat from 'react-number-format';
import inputStyles from '../Styles/inputStyles';
import styled from '../Styles/styled-components';

export const StyledNumberFormat = styled(NumberFormat)`
  ${inputStyles};
`;

export default StyledNumberFormat;
